// import components
import { Switch } from '@mui/material';

// import external libraries
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// import styles
import {
  StyledControlledTextField,
  StyledFilterComponentBox,
  StyledFormControlLabel,
  StyledSearchFieldBox
} from './FilterComponent.styles';

// import types
import {
  FilterComponentProps,
  FilterForm,
  Filters
} from './FilterComponent.types';

// import utils
import { defaultValues } from './FilterComponent.consts';

export const FilterComponent = ({
  handleFilterChange,
  dependencies = [],
  timeHighlight = false,
  includeInvalidDutyCodes,
  setIncludeInvalidDutyCodes,
  showDutyCodesSwitcher = false
}: FilterComponentProps) => {
  const { t } = useTranslation('common');
  const { control, watch } = useForm<FilterForm>({
    defaultValues: defaultValues
  });

  const [filters, setFilters] = useState<Filters>(defaultValues);
  const search = watch('search');

  const updateFilter = (value, propName) => {
    setFilters((prev) => ({ ...prev, [propName]: value }));
  };

  useEffect(() => {
    updateFilter(search ?? null, 'search');
  }, [search, ...dependencies]);

  useEffect(() => {
    handleFilterChange(filters);
  }, [filters, ...dependencies]);

  return (
    <StyledFilterComponentBox>
      <StyledSearchFieldBox>
        <StyledControlledTextField
          control={control}
          name="search"
          label={t('search')}
          timeHighlight={timeHighlight}
        />
      </StyledSearchFieldBox>
      {showDutyCodesSwitcher && (
        <StyledFormControlLabel
          label={t(`dutyCodes.includeInvalidDutyCodes`)}
          labelPlacement="start"
          control={
            <Switch
              checked={includeInvalidDutyCodes}
              onChange={(_, checked) => setIncludeInvalidDutyCodes?.(checked)}
            />
          }
        />
      )}
    </StyledFilterComponentBox>
  );
};
